import {page2, setSession, getSession} from '../../tools/config'

let obj = {
    state: {
        page2: {
            current: 1,
            size: 5,
            total: 0,
            index: 0,
        },

    },
    mutations: {


        setPage2(state, info) {
            setSession(page2, info)
            state.page2 = info
        },
        resetPage2(state) {
            setSession(page2, {
                current: 1,
                size: 5,
                total: 0,
                index: 0,
            }),
                state.page2= {
                    current: 1,
                    size: 5,
                    total: 0,
                    index: 0,
                }
        },
    },
    getters: {

        getPage2(state) {
            state.page2 = getSession(page2)
            return state.page2
        },

    }
}

export default obj



// WEBPACK FOOTER //
// ./src/store/modules/page2.js